import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextBoxStack20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTextBoxStack20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.5 4.5h-10a1 1 0 0 0-1 1V6h8A2.5 2.5 0 0 1 16 8.5v4h.5a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1M16 14h.5a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 16.5 3h-10A2.5 2.5 0 0 0 4 5.5V6h-.5A2.5 2.5 0 0 0 1 8.5v6A2.5 2.5 0 0 0 3.5 17h10a2.5 2.5 0 0 0 2.5-2.5zM3.5 7.5h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1m.75 2.25A.75.75 0 0 1 5 9h7a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M5 12a.75.75 0 0 0 0 1.5h3.416a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextBoxStack20);
